module.exports = __webpack_public_path__ + "static/media/claim-th.43141082.png";